module.exports = __webpack_public_path__ + "images/content/sf_team.png";